import { useState, useEffect, useCallback } from 'react';
import { useReaderAuth } from '../context/ReaderAuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useModuleProgress = () => {
  const { token, isAuthenticated } = useReaderAuth();
  const [progress, setProgress] = useState([]);
  const [loaded, setLoaded] = useState(false);

  // Fetch all section progress on mount
  useEffect(() => {
    if (!isAuthenticated?.()) { setLoaded(true); return; }
    fetch(`${API_URL}/api/modules/progress`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => { setProgress(Array.isArray(data) ? data : []); setLoaded(true); })
      .catch(() => setLoaded(true));
  }, [token, isAuthenticated]);

  // Upsert progress locally + persist to backend
  const saveProgress = useCallback(
    async (moduleNumber, lastSection, totalSections) => {
      if (!isAuthenticated?.()) return;

      // Optimistic local update
      setProgress((prev) => {
        const idx = prev.findIndex((p) => p.module_number === moduleNumber);
        const updated = { module_number: moduleNumber, last_section: lastSection, total_sections: totalSections };
        if (idx >= 0) { const next = [...prev]; next[idx] = updated; return next; }
        return [...prev, updated];
      });

      try {
        await fetch(`${API_URL}/api/modules/progress`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ module_number: moduleNumber, last_section: lastSection, total_sections: totalSections }),
        });
      } catch {
        // silently swallow — data will re-sync on next load
      }
    },
    [token, isAuthenticated]
  );

  const getModuleProgress = useCallback(
    (moduleNumber) => progress.find((p) => p.module_number === moduleNumber) || null,
    [progress]
  );

  return { progress, saveProgress, getModuleProgress, loaded };
};
